import { GridExceljsProcessInput } from '@mui/x-data-grid-premium';
import { some, uniq } from 'lodash';

import { paymentTypeMap } from 'components/pages/patient-source/Patients/constants';
import {
  BloodWorkCompletedOptions,
  OrderStatusOptions,
  PatientStatusOptionsForPMWorkbook
} from 'components/pages/patient-source/PmWorkbook/PMWorkbookTable/TableConstants';
import {
  ColumnOptions,
  PMWorkbookTableData,
  PMWorkbookTableRow
} from 'components/pages/patient-source/PmWorkbook/PMWorkbookTypes';

export const getColumnOptions = (data: PMWorkbookTableData): ColumnOptions => {
  const dynamicFieldNames: Array<string> = [
    'siteName',
    'patientSource',
    'edcCompletedBy',
    'bloodDrawStipend',
    'year1BloodDrawStipend',
    'year2BloodDrawStipend',
    'redrawStipend',
    'year1RedrawStipend',
    'year2RedrawStipend',
    'eproStipend',
    'pathologyReported',
    'colonoscopyEncounterSignOffStatus',
    'colonoscopyStipend',
    'eosReviewer',
    'eosReason',
    'methodOfFirstAttempt',
    'outcomeOfFirstAttempt',
    'firstAttemptCompletedBy',
    'methodOfSecondAttempt',
    'outcomeOfSecondAttempt',
    'secondAttemptCompletedBy',
    'methodOfThirdAttempt',
    'outcomeOfThirdAttempt',
    'thirdAttemptCompletedBy',
    'recordsAssistanceStipend',
    'reasonForColonoscopy',
    'patientRecordTransferStatus'
  ];

  const dynamicOptions = dynamicFieldNames.reduce(
    (options: Record<string, any[]>, fieldName: string): ColumnOptions => {
      options[fieldName] = uniq(
        data.map((row: PMWorkbookTableRow) => (row as Record<string, unknown>)[fieldName])
      ).filter(Boolean);
      return options;
    },
    {}
  );
  const staticOrNormalizedOptions: ColumnOptions = {
    bloodWorkCompleted: BloodWorkCompletedOptions,
    redrawBloodworkCompleted: BloodWorkCompletedOptions,
    year1BloodWorkCompleted: BloodWorkCompletedOptions,
    year1RedrawBloodworkCompleted: BloodWorkCompletedOptions,
    year2BloodWorkCompleted: BloodWorkCompletedOptions,
    year2RedrawBloodworkCompleted: BloodWorkCompletedOptions,
    orderStatus: OrderStatusOptions,
    redrawOrderStatus: OrderStatusOptions,
    year1OrderStatus: OrderStatusOptions,
    year1RedrawOrderStatus: OrderStatusOptions,
    year2OrderStatus: OrderStatusOptions,
    year2RedrawOrderStatus: OrderStatusOptions,
    paymentCard: Object.values(paymentTypeMap),
    patientStatus: PatientStatusOptionsForPMWorkbook,
    currentSubjectStatus: uniq(
      data.map((row: PMWorkbookTableRow) =>
        Array.isArray(row.currentSubjectStatus) ? row.currentSubjectStatus?.join(', ') : ''
      )
    )?.filter(Boolean)
  };
  return { ...staticOrNormalizedOptions, ...dynamicOptions };
};

export const populateDataWithDuplicates = (data: PMWorkbookTableData): PMWorkbookTableData => {
  return data.map((row: PMWorkbookTableRow) => {
    return {
      ...row,
      patientIdDuplicated: some(data, r => r.patientId === row.patientId && r.ssuPatientId !== row.ssuPatientId)
    };
  });
};

export const exceljsPostProcess = ({ worksheet }: GridExceljsProcessInput): Promise<void> => {
  worksheet.eachRow(row => {
    row.eachCell(cell => {
      cell.alignment = {
        wrapText: true
      };
    });
  });
  return Promise.resolve();
};
